import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteDriverMixerSalaryMutation } from 'bus/driverMixerSalary/services/driverMixerSalary';

type Props = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DriverMixerSalaryModalDelete: FC<Props> = ({ changeVisible, id, refresh, visible }) => {
  const [deleteDriverMixerSalary, { isLoading }] = useDeleteDriverMixerSalaryMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (id) await deleteDriverMixerSalary({ id });
    refresh();
    changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить?</div>

            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DriverMixerSalaryModalDelete;
